import type { UserRole } from '@bo-types/authentication';
import { selectUserRoles } from '@bo-services/authenticationSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/** Check if user roles contain this permission, or a role is super user. */
export function rolesHavePermission(
  userRoles: UserRole[],
  permissionName: string
): boolean {
  return userRoles.some((role) =>
    role.permissions.some((permission) => permission.name === permissionName)
  );
}

/** Memoized check if the current user has the given permission name, or is super user. */
export function useHasRolePermission(permissionName: string): boolean {
  const userRoles = useSelector(selectUserRoles);

  return useMemo<boolean>(
    () => rolesHavePermission(userRoles, permissionName),
    [permissionName, userRoles]
  );
}
